import { ExaminerMunicipality } from '../others/municipality-list.model'


export type AccessResponse = {
  accessToken: string;
  refreshToken: string;
}


export interface SessionData {
  logged?: boolean
  data: UserLogged
}

export interface UserResponsePayload {
  sub: number;
  run: string;
  name: string;
  last_name: string;
  examiner_municipalities: ExaminerMunicipality[];
}

export class UserLogged {
  token!: string
  run!: string
  name!: string
  last_name!: string
  municipalities!: ExaminerMunicipality[]
  photo?: string
  role_permissions?: string[]
  role?: string
  name_municipality?: string
  id_municipality?: number
  time?: any
}

export const emptyUser: any = {
  logged: false,
}

/*
export class UserLoggedResponse {
  token!: Token;
  body!: {
    run: number
    dv: string
    name: string
    last_name: string
    photo: string
    examiner_municipalities: ExaminerMunicipality
  }
}

export class UserLogged {
  token!: Token;
  run!: number
  dv!: string
  name!: string
  last_name!: string
  photo?: string
  role_permissions?: string[]
  role?: string 
  name_municipality?: string;
  id_municipality?: number;
}
*/
